"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiPaper = void 0;
var colors_1 = require("../colors");
exports.MuiPaper = {
    styleOverrides: {
        root: {
            '& .MuiPickersCalendarHeader-labelContainer': {
                overflow: 'visible',
            },
            '& .MuiPickersYear-yearButton.Mui-selected:focus-visible': {
                backgroundColor: colors_1.tannerBlack,
                color: colors_1.tannerWhite,
            },
            '& .MuiYearPicker-root': {
                '& .PrivatePickersYear-root': {
                    '& .PrivatePickersYear-yearButton': {
                        '&:focus, &:focus-visible': {
                            outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                            outlineOffset: 3,
                        },
                    },
                },
            },
        },
    },
};
//# sourceMappingURL=MuiPaper.js.map